import { ArrowBackComponent } from 'app/modules/GlobalComponents/arrow-back.component';
import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTabsModule } from '@angular/material/tabs';
import { ElementosVinculadosComponent } from 'app/modules/SharedEntitiesComponents/elementos-vinculados/elementos-vinculados';
import { DocumentosOficialesService } from '../documentos-oficiales/documentos-oficiales.service';
import { Observable } from 'rxjs';
import { ElementosVinculadosInterface } from 'app/models/elementos-vinculados-model';
import { BitacoraActividadesInterface } from 'app/models/bitacora.model';
import { DetalleDocumentosOficialesService } from './detalle-documentos-oficiales.service';
import { DocumentoGenerado } from '../../bienes-culturales/detalle-bien-cultural/tabs/documentos-emitidos/models/response-documento-generado';
import { DocumentosEmitidosService } from '../../bienes-culturales/detalle-bien-cultural/tabs/documentos-emitidos/documentos-emitidos.service';
import { UtilsService } from 'app/modules/utils-service';
import { CONSTANTS } from 'app/core/constants';
import { Router } from '@angular/router';
import { ActividadRecienteComponent } from 'app/modules/SharedEntitiesComponents/actividad-reciente/actividad-reciente';

@Component({
    selector: 'detalle-documentos-oficiales',
    templateUrl: 'detalle-documentos-oficiales.component.html',
    imports:[
        CommonModule, 
        ArrowBackComponent, 
        MatButtonModule, 
        MatIconModule, 
        MatTabsModule,

        //componentes
        ElementosVinculadosComponent,
        ActividadRecienteComponent
    ],
})

export class DetalleDocumentosOficialesComponent implements OnInit {
    elementosVinculadosDocumentos$:Observable<ElementosVinculadosInterface[]>
    bitacoraDocumento$:Observable<BitacoraActividadesInterface[]>
    documentoOficial$:Observable<DocumentoGenerado>
    linkElementoVinculado:string='/task-details/task'

    ID_ESTADO_BORRADOR_DOCUMENTO:number = CONSTANTS.ID_ESTADO_BORRADOR_DOCUMENTO

    constructor(
        private documentosOficialesService: DocumentosOficialesService,
        private detalleDocumentosOficiales: DetalleDocumentosOficialesService,
        private documentosEmititosService:DocumentosEmitidosService,
        private utilsService: UtilsService,
         private router: Router,
    ) { 
        this.elementosVinculadosDocumentos$= this.documentosOficialesService.elementosVinculadosDocumentos$
        this.bitacoraDocumento$= this.documentosOficialesService.bitacorasDocumento$
        this.documentoOficial$= this.detalleDocumentosOficiales.documentoOficial$
    }

    ngOnInit() { }

    downloadFile(documento: DocumentoGenerado): void {
        this.documentosEmititosService.getDocumentoBlob(documento.documentoGeneradoUuid)
            .then(blob => {
                this.utilsService.downloadFile(blob, documento.nombre, 'pdf');
            })
    }

    eliminarDocumento(documento: DocumentoGenerado) {
    
            this.utilsService.open_confirm_dialog(
                `Está seguro que desea Eliminar el documento ${documento.nombre}`, 
                `Eliminar Documento`
              )
            .subscribe(response=>{
                if (response === 'confirmed') {
                   this.documentosEmititosService.deleteDocumentoGenerado(documento.documentoGeneradoUuid, documento.bienCulturalUuid)
                    .then((response) => {
                        this.router.navigateByUrl(`/bienes-culturales/detalle/${documento.bienCulturalUuid}`)
                        this.utilsService.openSuccessSnakBar('Documento eliminado correctamente')
                        this.documentosEmititosService.getDocumentosGenerados(documento.bienCulturalUuid)
                    })
                }
            })
        }

}